import React, { useState, useEffect, useRef } from 'react';
import { Grid, Hidden } from '@material-ui/core';

import { Submenu, SubmenuItem } from '../../components';
import { documentsService /*, etfService*/ } from '../../service/';

import { getDateTimeString, smoothScroll } from '../../utils/functions';

import VisalGeralTexts from './texts';

import {
	Title,
	Container,
	Objetivo,
	ObjetivoConteudo,
	Politica,
	PoliticaConteudo,
	Publico,
	PublicoConteudo,
	PublicoImagem,
	Regras,
	RegrasConteudo,
	RegrasImg,
	RegrasTexto,
} from './styles';

export default () => {
	const [result, setResult] = useState('');

	const objetivoRef = useRef(null);
	const politicaRef = useRef(null);
	const publicoRef = useRef(null);
	const regrasRef = useRef(null);

	const getResult = async () => {
		try {
			throw new Error(); //force mock

			// const response = await etfService.Geral();
			// const responseData = await response.data;

			// setResult(responseData.ObjJsonResultado);
		} catch (err) {
			setResult(VisalGeralTexts);

			// console.error('Ocorreu um erro ao chamar a API Geral - Erro: ', err);
		}
	};

	const getFile = async path => {
		try {
			const response = await documentsService.downloadDocumento(path);
			const responseData = await response.data;

			const blob = new Blob([responseData], {
				type: 'application/pdf',
			});

			const downloadUrl = window.URL.createObjectURL(blob);

			const link = document.createElement('a');

			link.href = downloadUrl;
			link.download = `${path.replace('/', '')}PDF_${getDateTimeString()}.pdf`;

			document.body.appendChild(link);

			link.click();
			link.remove();
		} catch (err) {
			console.error(
				'Ocorreu um erro ao chamar a API de Download - Erro: ',
				err,
			);
		}
	};

	useEffect(() => {
		const getData = async () => {
			await getResult();
		};

		getData();
	}, []);

	const handleDownloadClick = path => getFile(path);

	return (
		<Container>
			<Hidden mdUp>
				<Title>Visão geral</Title>
			</Hidden>
			<Hidden smDown>
				<Submenu>
					<SubmenuItem
						onClick={() => smoothScroll('#objetivo')}
						label="Objetivo"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#politica')}
						label="Política de investimento"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#publico')}
						label="Público alvo"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#regras')}
						label="Regras de movimentação"
					/>
				</Submenu>
			</Hidden>

			<Objetivo>
				<ObjetivoConteudo ref={objetivoRef}>
					<div>
						<h2 id="objetivo">Objetivo</h2>
						<p>{result.Perfil?.Objetivo}</p>
					</div>
				</ObjetivoConteudo>
			</Objetivo>
			<Politica>
				<PoliticaConteudo ref={politicaRef}>
					<h2 id="politica">Política de investimento</h2>
					<p>{result.Perfil?.Politicainvestimento}</p>
					<br />
					<p>
						<strong>
							Não deixe de ler os Avisos legais na parte inferior deste site.
						</strong>
					</p>
				</PoliticaConteudo>
			</Politica>
			<Publico ref={publicoRef}>
				<PublicoConteudo>
					<div>
						<h2 id="publico">Público alvo</h2>
						<p>{result.Perfil?.PublicoAlvo}</p>
						<div>
							Para detalhamento dos fatores de risco,{' '}
							<strong
								onClick={() =>
									handleDownloadClick('/Caracteristicas/FatoresRisco')
								}
							>
								clique aqui
							</strong>{' '}
							ou acesse o menu Documentos &gt; Fatores de risco.
						</div>
					</div>
				</PublicoConteudo>
				<PublicoImagem />
			</Publico>
			<Regras>
				<RegrasConteudo ref={regrasRef}>
					<h2 id="regras">Regras de movimentação</h2>
					<Grid container>
						<RegrasImg item lg={1} md={1} sm={12} xs={12}>
							<img
								className="regrasimg"
								src="images/icone-regras-de-movimentacao-commodities-btg-pactual.png"
								alt="Ícone regras de movimentação commodities BTG Pactual"
							/>
						</RegrasImg>
						<RegrasTexto item lg={3} md={3} sm={12} xs={12}>
							<h3>Mercado secundário</h3>
							<p>{result.RegraMovimentacao?.MercadoSecundario}</p>
						</RegrasTexto>
						<RegrasTexto item lg={8} md={8} sm={12} xs={12}>
							<h3>Mercado primário</h3>
							<p>{result.RegraMovimentacao?.MercadoPrimario}</p>
						</RegrasTexto>
					</Grid>
					<div>
						Para requisição de empréstimo de ações para voto,{' '}
						<strong
							onClick={() =>
								handleDownloadClick('/Outros/RequerimentoEmprestimo')
							}
						>
							clique aqui
						</strong>{' '}
						ou acesse o menu Documentos &gt; Requerimento de empréstimo.
					</div>
				</RegrasConteudo>
			</Regras>
		</Container>
	);
};
